import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileProvider } from '../../providers/file/file';
import { Asset } from 'interfaces/asset.model';
import { EmailPackage } from 'interfaces/email-package.model';

export interface ModalData {
  finish: boolean,
  continue: boolean,
  isNew: boolean,
  email: string,
  existingPackage: EmailPackage,
  attachmentSize: number
};

@IonicPage()
@Component({
  selector: 'page-visit-package-modal',
  templateUrl: 'visit-package-modal.html',
})
export class VisitPackageModalPage {

  asset: Asset;
  onSelectNewOrExisting: string;
  emailPackages: EmailPackage[];
  packageForm: FormGroup;
  attachmentInvalid: boolean;
  emailInvalid: boolean;
  invalidFileSize: boolean;
  packageSizeInvalid: boolean;
  modalData: ModalData = {
    finish: false,
    continue: false,
    isNew: false,
    email: '',
    existingPackage: null,
    attachmentSize: 0
  };
  param = {assetname: ''};
  maxFileSize: number = 20; // file size in MB

  //[VP-27/04/2020] Use ChangeDetectorRef to force Angular to detect changes and refresh the interface 
  // because Modal content is not refreshed on the iPad when coming from PSPDFKit (cf. bugs #109 & #113)
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public params: NavParams,
    private fb: FormBuilder,
    private fileService: FileProvider,
    private cdr: ChangeDetectorRef
    ) {
      this.asset = params.get('asset');
      this.emailPackages = params.get('emailpackages');
      this.param.assetname = this.asset.AssetFile;
      this.onSelectNewOrExisting = 'new';
      this.attachmentInvalid = false;
      this.emailInvalid = false;
      this.invalidFileSize = false;
  
      this.packageForm = this.fb.group({
        newEmail: ['', [Validators.email]],
        selectedPackage: ['']
      });
  }

  ionViewDidLoad() {}

  backToAsset() {
    this.viewCtrl.dismiss(null);
  }

  addAndFinish() {
    this.modalData.finish = true;
    this.modalData.continue = false;

    this.fileService.getFileSize(this.asset.AssetPath).then((fileSize: number) => {
      const convertInMo = this.convertBytesToMegaBytes(fileSize);
      if(convertInMo < this.maxFileSize){
        this.asset.AssetSize = fileSize;
        console.log("THIS FILE IS ALLOWED");
        if(this.isNewPackage()) {
          this.createNewPackage();
        } else {
            this.updatePackage();
        }
      } else {
        console.log("LE FICHIER EST TROP GROS");
        this.invalidFileSize = true;
        this.cdr.detectChanges();
      }
    }).catch(err => console.log("Error: " + err));
  }

  addAndContinue(){
    this.modalData.finish = false;
    this.modalData.continue = true;
    
    this.fileService.getFileSize(this.asset.AssetPath).then((fileSize: number) => {
      const convertInMo = this.convertBytesToMegaBytes(fileSize);
      if(convertInMo < this.maxFileSize) {
        this.asset.AssetSize = fileSize;
        console.log("THIS FILE IS ALLOWED");
        if(this.isNewPackage()) {
          this.createNewPackage();
        } else {
            this.updatePackage();
        }
      } else {
        console.log("LE FICHIER EST TROP GROS");
        this.invalidFileSize = true;
        this.cdr.detectChanges();
      }
    }).catch(err => console.log("Error: " + err));
  }

  createNewPackage(){
    this.modalData.email = this.getEmailForm();
    this.modalData.isNew = true;
    this.modalData.attachmentSize = this.asset.AssetSize;

    if(this.emailPackages.length > 0)
    {
      if(this.checkNewEmail()){
        console.log("email already existing");
        this.emailInvalid = true;
        this.cdr.detectChanges();
      } else {
        this.viewCtrl.dismiss(this.modalData);
      }
    } else {
      this.viewCtrl.dismiss(this.modalData);
    }
  }

  updatePackage(){
    let selectedPackage = this.packageForm.value.selectedPackage;
    this.modalData.existingPackage = selectedPackage;
    this.modalData.isNew = false;

    if(this.checkAttachment(selectedPackage)){
      console.log("attachment already existing");
      this.attachmentInvalid = true;
      this.cdr.detectChanges();
    } else {
      if(this.checkPackageSize(selectedPackage)){
        this.modalData.existingPackage.size += this.asset.AssetSize;
        this.viewCtrl.dismiss(this.modalData);
      } else {
        this.packageSizeInvalid = true;
        this.cdr.detectChanges();
      }
      
    }
  }

  isNewPackage(){
    return this.onSelectNewOrExisting == 'new' ? true : false;
  }

  getEmailForm() {
    let email = this.onSelectNewOrExisting == 'new' ? this.packageForm.value.newEmail : this.packageForm.value.selectedPackage.email;
    return email;
  }

  checkNewEmail() {
    const newEmail = this.getEmailForm();
    return this.emailPackages.some(emailPackage => emailPackage.email == newEmail);
  }

  checkAttachment(selectedPackage: EmailPackage){
    return selectedPackage.attachments.some(attachment => attachment == this.asset.AssetId);
  }

  checkPackageSize(selectedPackage: EmailPackage){
    const packageSizeInMo = this.convertBytesToMegaBytes(selectedPackage.size);
    const assetSizeInMo = this.convertBytesToMegaBytes(this.asset.AssetSize);
    let packageSize = packageSizeInMo + assetSizeInMo;
    if(packageSize < this.maxFileSize){
      return true;
    } else {
      return false;
    }
  }

  onChangeRadioNewExisting(){
    this.packageForm.reset();
    this.emailInvalid = false;
    this.attachmentInvalid = false;
    this.invalidFileSize = false;
    this.packageSizeInvalid = false;
    this.cdr.detectChanges();
  }

  onChangeSelectedPackage(){
    this.attachmentInvalid = false;
    this.packageSizeInvalid = false;
    this.cdr.detectChanges();
  }

  invalidForm(){
    let newEmail = this.packageForm.value.newEmail;
    let selectedPackage = this.packageForm.value.selectedPackage;
    return ((newEmail == '' || newEmail == null) && (selectedPackage == '' || selectedPackage == null)) ? true : false;
  }

  convertBytesToMegaBytes(fileSize){
    return Math.round(fileSize / 1048576);
  }

}



// WEBPACK FOOTER //
// ./src/pages/visit-package-modal/visit-package-modal.ts